import React from 'react';
import './Hero/Hero.css';

const FEATURES = [
  'Hands-on Learning Infrastructure',
  'End-to-End Lab Setup',
  'Industry-Standard Equipment',
  'Complete Hardware + Software Support',
];

function CheckIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="2,7 6,11 12,3" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default function FeaturesBar() {
  return (
    <div className="features-bar">
      {FEATURES.map((label) => (
        <div className="feature-item" key={label}>
          <div className="feature-icon">
            <CheckIcon />
          </div>
          <span className="feature-label">{label}</span>
        </div>
      ))}
    </div>
  );
}